import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { of } from "rxjs";
import { catchError, map, mergeMap } from "rxjs/operators";
import { V2AdminService } from "../../../services/api/v2-admin.service";
import { MpAdminActions } from "../../actions/mp-admin.actions";
import { FailState } from "../../models/fail-state";

@Injectable()
export class ConsumerStatusEffects {
	disableConsumer = createEffect(() =>
		this.actions$.pipe(
			ofType(MpAdminActions.consumer.disable),
			mergeMap((action) =>
				this.adminService.disableConsumer(action.id, action.accountStatusRemarks).pipe(
					map(() => MpAdminActions.consumer.disableSuccess({ id: action.id })),
					catchError((error) =>
						of(MpAdminActions.consumer.disableFail(new FailState(error)))
					)
				)
			)
		)
	);

	enableConsumer = createEffect(() =>
		this.actions$.pipe(
			ofType(MpAdminActions.consumer.enable),
			mergeMap((action) =>
				this.adminService.enableConsumer(action.id, action.accountStatusRemarks).pipe(
					map(() => MpAdminActions.consumer.enableSuccess({ id: action.id })),
					catchError((error) =>
						of(MpAdminActions.consumer.enableFail(new FailState(error)))
					)
				)
			)
		)
	);

	/*	enableConsumerSuccess = createEffect(() =>
		this.actions$.pipe(
			ofType(MpAdminActions.consumer.enableSuccess),
			map((action) => {
				return MpCommonActions.activeConsumers.getApi({ params: { id: action.id } });
			})
		)
	);*/

	constructor(
		private actions$: Actions,
		private adminService: V2AdminService
	) {}
}
